import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AuthPageLayout from "../../../components/layout/AuthPageLayout";
import { ErrorAlertIcon } from "../../../components/Icons";
import { ROUTES } from "../../../constants";
import {
  ErrorContainer,
  ErrorIconContainer,
  ErrorTitle,
  ErrorSubtitle,
  ErrorActions,
} from "./RegistrationErrorPage.styled";

const RegistrationErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate(ROUTES.LOGIN);
  };

  const handleGoToRegister = () => {
    navigate(ROUTES.FORGOT_PASSWORD);
  };

  return (
    <AuthPageLayout contentWidth="500px">
      <ErrorContainer>
        <ErrorIconContainer>
          <ErrorAlertIcon width="80px" height="80px" />
        </ErrorIconContainer>

        <ErrorTitle>{t("registrationError.title")}</ErrorTitle>

        <ErrorSubtitle>{t("registrationError.subtitle")}</ErrorSubtitle>

        <ErrorActions>
          <Button variant="outlined" onClick={handleGoToRegister}>
            {t("registrationError.requestNewLink")}
          </Button>

          <Button variant="contained" onClick={handleGoToLogin}>
            {t("registrationError.goToLogin")}
          </Button>
        </ErrorActions>
      </ErrorContainer>
    </AuthPageLayout>
  );
};

export default RegistrationErrorPage;
